import React from 'react';
import Button from 'components/UI/Button';
import { useTrans } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';
import * as styles from './ModalFooter.module.scss';

function ModalFooter({ handleClear, handleShowResults, filtersAmount, resultsAmount }) {
  const t = useTrans(['common', 'filters']);

  const showResults = () => {
    handleShowResults();
    pushCustomEvent('ndrsn_projects_filtration', { action: 'click_on_show_results_button' });
  };

  return (
    <div className={styles.modalFooter}>
      <div className={styles.buttonsWrapper}>
        <Button onClick={handleClear} theme="secondary" disabled={!filtersAmount}>
          {t('clearAll')}
          {Boolean(filtersAmount) && ` (${filtersAmount})`}
        </Button>
        <Button onClick={showResults}>
          {t('results')}
          {Boolean(resultsAmount) && ` (${resultsAmount})`}
        </Button>
      </div>
    </div>
  );
}

export default ModalFooter;
